import React from "react";
import withIntl from "../../utils/withIntl";
import { MenuItem, Select } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  textFieldContainer: {
    display: "flex",
    margin: 10,
  },
  label: { width: "40%" },
  input: { width: "60%" },
}));

function SelectForm(props) {
  const classes = useStyles();

  return (
    <div className={classes.textFieldContainer}>
      <div className={classes.label}>
        <Typography>{props.label}</Typography>
        <Typography variant="caption" style={{ color: "gray" }}>
          {props.helperTextLabel ? props.helperTextLabel : ""}
        </Typography>
      </div>
      <div className={classes.input}>
        <Select
          size={"small"}
          variant={props.variant ?? "standard"}
          fullWidth
          value={props.value ?? ""}
          onChange={(e) => props.handleSelect(e.target.value)}
        >
          {props.menuItems.map((item) => {
            return <MenuItem value={item.name}>{item.name}</MenuItem>;
          })}
        </Select>
      </div>
    </div>
  );
}

export default withIntl(SelectForm);
